import {Component, Input} from 'ng-metadata/core';

import serviceProviders, { CitationTrailsFullviewLinkService } from './citationTrailsFullviewLink.service';
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {TimesCitedService} from "../timesCited/timesCited.service";
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';


@Component({
selector: 'prm-citation-trails-fullview-link',
templateUrl: 'components/search/citationTrails/citation-trails-fullview-link.html',
})

export class PrmCitationTrailsFullviewLink{
    @Input() public type	: string;

    @Input() public record :PrimoResponse.IExtendedDoc;
    constructor(private citationTrailsFullviewLinkService: CitationTrailsFullviewLinkService,
                private timesCitedService: TimesCitedService,
                private configurationUtil: ConfigurationUtil) {
    }

    public hasCitedby(){
        return this.citationTrailsFullviewLinkService.hasCitedby(this.record);
//        return this.record.extras.citationTrails.citedby && this.record.extras.citationTrails.citedby.length > 0;
    }

    public hasCiting(){
        return this.citationTrailsFullviewLinkService.hasCiting(this.record);
//        return this.record.extras.citationTrails.citing && this.record.extras.citationTrails.citing.length > 0;
    }

    	public getLabel() {
		return this.type === 'citing' ? 'nui.citation_trail.link.citing' : 'nui.citation_trail.link.citedin';
	}

	get shouldDisplayTimesCited(){
        return this.citationTrailsFullviewLinkService.shouldDisplayTimesCited();
        //shouldDisplayTimesCited
    }

    get shouldDisplayCitationTrial(){
        return this.citationTrailsFullviewLinkService.shouldDisplayCitationTrial();

    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/citationTrails/citationTrailsFullviewLink.directive.ts